import { atom } from 'recoil';

export interface SettingsSidebarState {
  selectedParentKey: string;
  expandedParentKeys: string[];
}

export const settingsSidebarStateAtom = atom<SettingsSidebarState>({
  key: 'settingsSidebarState',
  default: {
    selectedParentKey: 'profile',
    expandedParentKeys: [],
  },
});
